import { Box, Typography } from '@mui/material';
import { ImageWrapper, pxToRem, pxTovW } from '@geneo2-web/shared-ui';

const ProjectDashboardBanner = () => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.imageBox}>
        <ImageWrapper
          name="project_dashboard_Icon1"
          type="png"
          parentFolder="tempAssets"
          styles={{
            ...styles.image,
            height: '100%',
          }}
        />
      </Box>
      <Typography
        variant="g1"
        sx={{
          fontFamily: 'lato', // DOUBT::: why this font family here?
          textAlign: { xs: 'center', lg: 'left' },
          // On md (tablet) the title sits on its own full-width row above
          // the image + info card, which are laid out side by side.
          width: { md: '100%', lg: 'auto' },
          order: { md: 1, lg: 0 },
          fontSize: {
            xs: pxToRem(20),
            sm: pxToRem(24),
            md: pxToRem(28),
            lg: pxTovW(48),
          },
        }}
      >
        Geneo Innovation Lab
      </Typography>
      <Box sx={styles.rightContainer}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            minWidth: 0,
            flex: 1,
            pl: { xs: pxToRem(16), md: pxToRem(24), lg: pxTovW(37) },
          }}
        >
          <Typography
            variant="bodyText"
            sx={{
              fontSize: {
                xs: pxToRem(15),
                sm: pxToRem(18),
                md: pxToRem(22),
                lg: pxTovW(28),
              },
              fontWeight: 600,
              lineHeight: 1.3,
              mb: { xs: pxToRem(6), md: pxToRem(10), lg: pxTovW(12) },
            }}
          >
            Keep learning, keep exploring!
          </Typography>

          <Typography
            sx={{
              fontSize: {
                xs: pxToRem(12),
                sm: pxToRem(14),
                md: pxToRem(18),
                lg: pxTovW(24),
              },
              fontWeight: 500,
              lineHeight: 1.25,
            }}
          >
            You're doing great. Let's achieve more today
          </Typography>
        </Box>

        {/* Right Image */}
        <Box
          sx={{
            width: {
              xs: pxToRem(70),
              sm: pxToRem(90),
              md: pxToRem(120),
              lg: pxTovW(170),
            },
            height: '100%',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            flexShrink: 0,
          }}
        >
          <ImageWrapper
            name="robo"
            type="png"
            parentFolder="tempAssets"
            styles={{
              position: 'absolute',
              right: 0,
              bottom: { xs: pxToRem(-6), md: pxToRem(-10), lg: '-15px' },
              width: {
                xs: pxToRem(80),
                sm: pxToRem(100),
                md: pxToRem(140),
                lg: pxTovW(190),
              },
              height: {
                xs: pxToRem(80),
                sm: pxToRem(100),
                md: pxToRem(140),
                lg: pxTovW(190),
              },
              objectFit: 'contain',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectDashboardBanner;

const styles = {
  container: {
    display: 'flex',
    flexWrap: { xs: 'nowrap', md: 'wrap', lg: 'nowrap' },
    justifyContent: { xs: 'flex-start', lg: 'space-between' },
    alignItems: { xs: 'stretch', lg: 'center' },
    gap: { xs: pxToRem(16), md: pxToRem(20), lg: pxTovW(33) },
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
  },
  imageBox: {
    width: { xs: '100%', md: pxToRem(240), lg: pxTovW(245) },
    minWidth: { md: pxToRem(150) },
    height: {
      xs: pxToRem(160),
      sm: pxToRem(200),
      md: pxToRem(180),
      lg: pxTovW(233),
    },
    flexShrink: { xs: 0, md: 1, lg: 0 },
    order: { md: 2, lg: 0 },
  },
  image: {
    width: '100%',
    // Contain on md so the full illustration is visible next to the card;
    // cover elsewhere to fill the taller banner slot.
    objectFit: { xs: 'cover', md: 'contain', lg: 'cover' },
    borderRadius: { xs: pxToRem(16), lg: pxTovW(16) },
  },
  rightContainer: {
    width: { xs: '100%', md: 'auto', lg: pxTovW(581) },
    // md: basis 0 + grow 1 -> takes only the space left beside the image,
    // so the two never wrap onto separate rows.
    flexBasis: { xs: 'auto', md: 0, lg: 'auto' },
    flexGrow: { xs: 0, md: 1, lg: 0 },
    flexShrink: { xs: 0, md: 1, lg: 0 },
    minWidth: { xs: 0, md: pxToRem(260) },
    order: { md: 3, lg: 0 },
    height: {
      xs: pxToRem(150),
      sm: pxToRem(160),
      md: pxToRem(180),
      lg: pxTovW(194),
    },
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #475D99',
    borderRadius: { xs: pxToRem(16), md: pxToRem(20), lg: pxTovW(24) },
    overflow: 'hidden',
    background: '#fff',
  },
};
